import { mivoDb } from "@/domains/offline/db/mivoDb";
import type { OutboxEntry } from "@/domains/offline/db/schema";

export async function enqueueOutbox(entry: Omit<OutboxEntry, "retries" | "status">): Promise<OutboxEntry> {
  const row: OutboxEntry = { ...entry, retries: 0, status: "pending" };
  await mivoDb.outbox.put(row);
  return row;
}

export async function listPendingOutbox(): Promise<OutboxEntry[]> {
  return mivoDb.outbox.where("status").equals("pending").sortBy("createdAt");
}

export async function listFailedOutbox(): Promise<OutboxEntry[]> {
  return mivoDb.outbox.where("status").equals("failed").sortBy("createdAt");
}

export async function removeOutbox(id: string): Promise<void> {
  await mivoDb.outbox.delete(id);
}

export async function markOutboxFailed(id: string, errorMessage: string): Promise<void> {
  const row = await mivoDb.outbox.get(id);
  if (!row) {
return;
}
  await mivoDb.outbox.put({ ...row, status: "failed", errorMessage, retries: row.retries + 1 });
}

export async function incrementOutboxRetry(id: string): Promise<void> {
  const row = await mivoDb.outbox.get(id);
  if (!row) {
return;
}
  await mivoDb.outbox.put({ ...row, retries: row.retries + 1 });
}

export async function countPendingOutbox(): Promise<number> {
  return mivoDb.outbox.where("status").equals("pending").count();
}
